module.exports = __webpack_public_path__ + "static/img/usericon.945a243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usericon.png
// module id = ur+s
// module chunks = 1